<template>
  <v-card :class="item.IsActive ? '' : 'deactivated'" flat class="rounded-0" @click="$emit('click')">
    <v-row no-gutters class="px-3 py-2">
      <v-col cols="auto">
        <v-icon size="20">$supplier</v-icon>
      </v-col>
      <v-col cols="auto" class="px-3" style="opacity: 0.7;">
        {{ item.SupplierNumber }}
      </v-col>
      <v-col cols="0">
        {{ item.Name }}
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
export default {
  name: 'SupplierListItem',
  props: {
    item: Object,
  },
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>